import {createContext, useContext} from "react";
import LanguageStore from "./LanguageStore";
import ContactFormStore from "./ContactFormStore";
import AccordionStore from "./AccordionStore";
import ImageStore from "./ImageStore";
import UserStore from "./UserStore";
import {GlobalMessageStore} from "./GlobalMessageStore";
import CreditTextsStore from "./CreditTextsStore";
import SettingsStore from "./SettingsStore";

interface Store {
    LanguageStore: LanguageStore;
    ContactFormStore: ContactFormStore;
    AccordionStore: AccordionStore;
    ImageStore: ImageStore;
    UserStore: UserStore;
    GlobalMessageStore: GlobalMessageStore;
    CreditTextsStore: CreditTextsStore;
    SettingsStore: SettingsStore;
}

export const store: Store = {
    LanguageStore: new LanguageStore(),
    ContactFormStore: new ContactFormStore(),
    AccordionStore: new AccordionStore(),
    ImageStore: new ImageStore(),
    UserStore: new UserStore(),
    GlobalMessageStore: new GlobalMessageStore(),
    CreditTextsStore: new CreditTextsStore(),
    SettingsStore: new SettingsStore(),
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}